"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Cookies", {
  enumerable: true,
  get: function get() {
    return _Cookies.default;
  }
});
Object.defineProperty(exports, "CookiesProvider", {
  enumerable: true,
  get: function get() {
    return _CookiesProvider.default;
  }
});
Object.defineProperty(exports, "withCookies", {
  enumerable: true,
  get: function get() {
    return _withCookies.default;
  }
});

var _Cookies = _interopRequireDefault(require("./Cookies"));

var _CookiesProvider = _interopRequireDefault(require("./CookiesProvider"));

var _withCookies = _interopRequireDefault(require("./withCookies"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie/cjs/index.js
// module id = 45
// module chunks = 35783957827783 162898551421021 251080691916612